import { useMemo } from 'react'
import { useFormikContext } from 'formik'
import { IServiceProduct, SERVICE_TYPE } from '@user/store/serviceProducts'

import { ILeadOppProductFormModel } from '../typings'

type Props = {
  serviceProducts: IServiceProduct[]
}

export function useAutocomplete(props: Props) {
  const { serviceProducts } = props

  const {
    values: { externalId },
  } = useFormikContext<ILeadOppProductFormModel>()

  const autoCompleteValue = useMemo(
    () => serviceProducts.find((x) => x.id === externalId) ?? null,
    [externalId, serviceProducts],
  )

  const autoCompleteOptions = useMemo(() => {
    const services = [...serviceProducts]
      .filter((item) => item.serviceType === SERVICE_TYPE.SERVICE)
      .sort((a, b) => -(b.name + b.name).localeCompare(a.name + a.name))
    const products = [...serviceProducts]
      .filter((item) => item.serviceType === SERVICE_TYPE.PRODUCT)
      .sort((a, b) => -(b.name + b.name).localeCompare(a.name + a.name))
    return [...services, ...products]
  }, [serviceProducts])

  return {
    autoCompleteValue,
    autoCompleteOptions,
  }
}
